<template>
  <v-card class="mx-auto mt-4 rounded-card" elevation="4" max-width="800">
    
    <v-card-title class="font-weight-bold text-wrap">
      {{ this.description }}
    </v-card-title>
    <div class="container">
      <div class="container">
        <div class="row justify-content-start">
          <div class="ml-1">
            <v-icon>mdi-account-outline</v-icon>
            <label>  Full Name : {{ this.fullName }} </label>
          </div>
        </div>
      </div> 
      <div class="row justify-content-start">
        <v-card-subtitle> phone Number: {{ this.phoneNumber }}</v-card-subtitle>
        <v-card-subtitle> Location: Addis Ababa </v-card-subtitle>
        <v-card-subtitle> Date: {{ this.date }} </v-card-subtitle>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  data: () => ({ }),

  props: {
    date: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: true,
    },
    fullName: {
      type: String,
      required: false,
    },
    location: {
      type: Object,
      required: true,
    },
    phoneNumber: {
      type: String,
      required: false,
    },
    userId: {
      type: String,
      required: false,
    },
  },
};
</script>